export const whitespace = /[ \t\r\n]/;
